"use strict";
// Copyright © Veeam Software Group GmbH
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LoginLanguageSelectorButton = exports.LoginLanguageSelectorButtonWrapperArrow = void 0;
const styled_components_1 = __importStar(require("styled-components"));
const helpers_1 = require("../../../../helpers");
const Icon_1 = require("../../../../Icon");
const StackView_1 = require("../../../../StackView");
exports.LoginLanguageSelectorButtonWrapperArrow = styled_components_1.default.div `
    display: flex;
    width: calc(${helpers_1.SPACING_XL} - 2 * ${helpers_1.BASE_BORDER_WIDTH});
    height: 100%;

    > svg {
        fill: ${({ theme }) => theme.colorLoginTitle};
    }
`;
exports.LoginLanguageSelectorButton = (0, styled_components_1.default)(StackView_1.StackView) `
    display: inline-flex;
    height: ${helpers_1.SPACING_XL};
    font: ${helpers_1.BASE_FONT};
    cursor: pointer;

    ${({ theme }) => (0, styled_components_1.css) `
        color: ${theme.colorLoginTitle};

        ${Icon_1.Icon.selector} {
            color: ${theme.colorLoginTitle};
        }
    `}

    ${({ disabled, theme }) => !disabled &&
    (0, styled_components_1.css) `
            &:hover {
                background-color: ${theme.colorLoginSSOButtonHover};
            }

            &:active {
                background-color: ${theme.colorLoginSSOButtonActive};
            }
        `}

    ${({ disabled }) => disabled &&
    (0, styled_components_1.css) `
            cursor: default;
            opacity: 0.3;

            &:hover,
            &:active {
                background-color: transparent;
            }
        `}

    ${({ isActive, theme }) => isActive &&
    (0, styled_components_1.css) `
            &,
            &:hover,
            &:active {
                background-color: ${theme.colorLoginSSOButtonActive};
            }
        `}
`;
//# sourceMappingURL=LoginLanguageSelector.styles.js.map